import React from "react";
import dynamic from 'next/dynamic';
import {Card, Select, Space} from "antd";
import style from "./chartSales.module.scss";
import {useTranslations} from "next-intl";

const Line = dynamic(() => import('@ant-design/plots').then(({ Line }) => Line),
    { ssr: false }
);

export const SalesChart = ({info, onChangeFilter}) => {
    const t = useTranslations('dashboard');
    const config = {
        data: info ?? [],
        xField: 'date',
        yField: 'value',
        colorField: 'type',
        scale: { color: { range: ['#C95F5F', '#9B2525', '#9A5151'] } },
        height: 365,
        maxWidth: 910,
        style: {
            lineWidth: 2,
        },
    };

    const types = [
        {
            id: 'subscriptions',
            value: t('subscriptions')
        },
        {
            id: 'connections',
            value: t('connections')
        },
    ];

    return (
        <>
            <div className={style.block}>
                <Card
                    title={t('sales')}
                    className={'charts'}
                    extra={(
                        <Space>
                            <Select
                                style={{width: '168px'}}
                                className='primary'
                                defaultValue={'connections'}
                                options={types}
                                fieldNames={{ value: 'id', label: 'value' }}
                                onChange={(value) => onChangeFilter('sales_type', value)}
                            />
                        </Space>
                    )}
                >
                    {info && info.length ?
                        <Line {...config} /> :
                        <div className={style.not_found}>{t('not_found')}</div>
                    }
                </Card>
            </div>
        </>
    );
}